import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINT } from "../../config";
import { LandingDetails } from "../../interfaces";
import { toastMessage } from "../../utils/toastError";

export const landingApi = createApi({
  reducerPath: "landingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/landing",
    credentials: "include",
  }),
  endpoints: (build) => ({
    getLandingDetails: build.query<LandingDetails, void>({
      query: () => ({
        url: "",
        method: "GET",
      }),
    }),

    updateLandingDetails: build.mutation<any, LandingDetails>({
      query: (payload) => ({
        url: "",
        method: "PUT",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue) {
        toastMessage("success", "Landing page updated successfully");
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const {
  useGetLandingDetailsQuery,
  useUpdateLandingDetailsMutation,
} = landingApi;
